export default {
  // 右鍵菜單項
  viewDetails: "查看詳情",
  viewDetailsShortcut: "查看詳情(ctrl+e)",
  noteNode: "備註節點",
  noteNodeShortcut: "備註節點(alt+v/⌥+v)",
  joinMonitoring: "加入監控",
  joinMonitoringShortcut: "加入監控(ctrl+m)",
  joinSurvey: "加入調證",
  ordinarySurvey: "普通調證",
  keySurvey: "重點調證",
  joinDashboard: "加入看板",
  transactionDashboard: "交易數據看板",
  balanceDashboard: "餘額數據看板",
  aiModel: "AI模型",
  firstFeesModel: "首筆手續費模型",
  relatedFeesModel: "關聯手續費模型",
  tornadoModel: "龍捲風模型",
  newCanvas: "新建畫布",
  newCanvasShortcut: "新建畫布(alt+g/⌥+g)",
  copyAddress: "複製地址",
  copyAddressShortcut: "複製地址(ctrl+c)",

  // 提示消息
  noteSuccess: "備註成功",
  noteFailed: "備註失敗,請刷新重試!",
  addedToSurvey: "已加入調證",
  notSupportMonitoring: "該地址暫不支持地址監控!",
  notSupportModel: "該地址暫不支持模型驗證!",
  submitSuccess: "提交成功,等待驗證結果",
};
